import { Interweave } from "interweave";
import {
  Body,
  Container,
  ContentWrapper,
  Header,
  Section,
  Separator,
  Thumbnail,
  UserDetails,
  UserName,
  UserRole,
  Wrapper,
  WrittenByWrapper,
  UserThumbnail,
} from "./styled";
import moment from "moment";
import TableLoader from "../../../library/table-loader";
import thumbnail from "../../../assets/img/thumbnail.svg";
import { Title } from "../../../library/title";
import { Text } from "../../../library/text";
import middleSeparator from "../../../assets/img/middle_separator.svg";
import BottomView from "../../index/bottom-view";

interface IContentProps {
  content: any;
  loading: boolean;
}

const Content: React.FC<IContentProps> = ({ content, loading }) => {
  const renderView = () => {
    if (loading) {
      return <TableLoader />;
    }
    return (
      <>
        <Header>
          <Container>
            <Wrapper top={true}>
              <Title size="xl">{content?.title}</Title>
              <Text size="regular" color="light">
                Publisert {moment.unix(content.timestamp).format("DD/MM/YYYY")}
              </Text>
              <Thumbnail
                alt={`Randi - ${content?.title}`}
                src={content?.thumbnail}
              />
            </Wrapper>
          </Container>
          <Separator src={middleSeparator} />
        </Header>
        <Body>
          <Container>
            <Wrapper top={false}>
              <WrittenByWrapper>
                <UserThumbnail src={thumbnail} />
                <UserDetails>
                  <UserName>Andreas Skaalerud</UserName>
                  <UserRole>Founder</UserRole>
                </UserDetails>
              </WrittenByWrapper>
              <ContentWrapper>
                <Interweave
                  allowList={[
                    "iframe",
                    "div",
                    "p",
                    "a",
                    "h2",
                    "strong",
                    "script",
                    "ul",
                    "li",
                  ]}
                  allowAttributes={true}
                  content={content?.content}
                />
              </ContentWrapper>
            </Wrapper>
          </Container>
        </Body>
        <BottomView />
      </>
    );
  };

  return <Section>{renderView()}</Section>;
};

export default Content;

/*
<Wrapper>
        <Title size="xl">{content?.title}</Title>
        <Thumbnail alt={`Randi - ${content?.title}`} src={content?.thumbnail} />
        <IllustrationWrapper>
          <Illustration src={middleSeparator} />
        </IllustrationWrapper>
        <Published>
          Publisert {moment.unix(content.timestamp).format("HH:mm DD/MM/YYYY")}
        </Published>
        <ArticleContent>
          <Interweave
            allowList={["iframe", "div", "p", "a", "h2", "strong", "script"]}
            allowAttributes={true}
            content={content?.content}
          />
        </ArticleContent>
      </Wrapper>
*/
